import React, { useState, useRef, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import InputField from '../../../../Components/InputField';
import Button from '../../../../Components/Button';
import SelectBox from '../../../../Components/Select';
import SelectBox1 from '../../../../Components/Select1';
import DateTimeRangePicker from '../../../../Components/dateTimeRangePicker';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { GlobalContext } from '../../../../GlobalContext';
import { toast } from 'react-toastify';

const UnitBoundingList = () => {

    const navigate = useNavigate();
    const { currentTab, setCurrentTab } = useContext(GlobalContext);

    useEffect(() => {
        setCurrentTab('Bounding list');
    });

    const token = localStorage.getItem('unittoken');
    const decodedToken = jwtDecode(token);
    const userId = { userID: decodedToken.id }

    //--------------mouse drage(resize width)--------------
    const containerRef = useRef(null);
    const [columnWidths, setColumnWidths] = useState([]);
    const [isResizing, setIsResizing] = useState(false);
    const [startX, setStartX] = useState(0);
    const [currentColumnIndex, setCurrentColumnIndex] = useState(null);
    const numberOfColumns = 6; // Adjust this based on your actual number of columns

    useEffect(() => {
        const containerWidth = containerRef.current ? containerRef.current.clientWidth : 0;
        const initialWidth = containerWidth / numberOfColumns; // Divide the container width by the number of columns
        setColumnWidths(Array(numberOfColumns).fill(initialWidth)); // Set initial widths
    }, []);

    const handleMouseDown = (e, index) => {
        e.preventDefault(); // Prevent default behavior
        setIsResizing(true);
        setStartX(e.clientX);
        setCurrentColumnIndex(index);
    };

    const handleMouseMove = (e) => {
        if (isResizing && currentColumnIndex !== null) {
            const newWidths = [...columnWidths];
            const newWidth = newWidths[currentColumnIndex] + (e.clientX - startX);
            newWidths[currentColumnIndex] = Math.max(newWidth, 50); // Prevent column from being too small

            // Calculate total width of columns
            const totalWidth = newWidths.reduce((acc, width) => acc + width, 0);
            const containerWidth = containerRef.current.clientWidth; // Get the container width

            // If total width exceeds container width, adjust the widths proportionally
            if (totalWidth > containerWidth) {
                const excessWidth = totalWidth - containerWidth;
                const adjustment = excessWidth / (newWidths.length - 1); // Adjust all but the resized column

                newWidths.forEach((_, idx) => {
                    if (idx !== currentColumnIndex) {
                        newWidths[idx] = Math.max(newWidths[idx] - adjustment, 50); // Prevent columns from being too small
                    }
                });
            }

            setColumnWidths(newWidths);
            setStartX(e.clientX);
        }
    };

    const handleMouseUp = () => {
        setIsResizing(false);
        setCurrentColumnIndex(null);
    };

    useEffect(() => {
        if (isResizing) {
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
        }

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isResizing, currentColumnIndex]);

    const headArray = ['Serial number', 'Geo-Fence Name', 'Number of members','Trigger method','Creation Time','Operation'];

    const [selectGroupType] = ['Please select group type', 'Fixed group', 'User-created groups'];
    const selectPageArray = ['20/page', '40/page', '60/page', '80/page'];

    const [recordData, setRecordData] = useState([]);

    // useEffect(() => {
    //     const fetch = async () => {
    //         const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

    //         if (!POCBaseUrl) {
    //             throw new Error('API base URL is not defined');
    //         }

    //         await axios.post(`${POCBaseUrl}/unitgroups/unitget`, { userId },
    //             {
    //                 headers: {
    //                     "Content-Type": "application/json", // Specify content type
    //                     Authorization: `Bearer ${token}`, // Include the token
    //                 },
    //             }
    //         )
    //             .then(response => {
    //                 console.log('groupData', response.data.data);
    //                 setGroupData(response.data.data);
    //             })
    //             .catch(error => {
    //                 console.error("There was an error fetching the customer data!", error);
    //             });
    //     }
    //     fetch();
    // }, []);

    const [groupData, setGroupData] = useState(['no data']); 
    // useEffect(() => {
    //     const fetch = async () => {
    //         const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

    //         if (!POCBaseUrl) {
    //             throw new Error('API base URL is not defined');
    //         }

    //         await axios.post(`${POCBaseUrl}/unitgroups/unitget`, {userId},
    //             {
    //                 headers: {
    //                   "Content-Type": "application/json", // Specify content type
    //                   Authorization: `Bearer ${token}`, // Include the token
    //                 },
    //               }
    //         )
    //         .then(response => {
    //             setGroupData(response.data.data);
    //         })
    //         .catch(error => {
    //             console.error("There was an error fetching the customer data!", error);
    //         });
    //     }
    //     fetch();
    // }, []);
    const [userData, setUserData] = useState(['no data']); 
    // useEffect(() => {
    //     const fetch = async () => {
    //         const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

    //         if (!POCBaseUrl) {
    //             throw new Error('API base URL is not defined');
    //         }

    //         await axios.post(`${POCBaseUrl}/unitgroups/unitget`, {userId},
    //             {
    //                 headers: {
    //                   "Content-Type": "application/json", // Specify content type
    //                   Authorization: `Bearer ${token}`, // Include the token
    //                 },
    //               }
    //         )
    //         .then(response => {
    //             setUserData(response.data.data);
    //         })
    //         .catch(error => {
    //             console.error("There was an error fetching the customer data!", error);
    //         });
    //     }
    //     fetch();
    // }, []);

    const [searchKey, setSearchKey] = useState({ group_name: '', user_name: '', start_date: '', end_date:'' });
    const handleDataFromChild = (data) => {
        setSearchKey({
            ...searchKey,
            ['group_name']: data,
        });
    };
    const handleDataFromChild1 = (data) => {
        setSearchKey({
            ...searchKey,
            ['user_name']: data,
        });
    };
    const searchRecord = async () => {
        const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

        if (!POCBaseUrl) {
            throw new Error('API base URL is not defined');
        }
        const searchValue = { searchKey: searchKey };
        // await axios.post(`${POCBaseUrl}/unitgroups/unitsearch`, { userId, searchValue },
        //     {
        //         headers: {
        //             "Content-Type": "application/json", // Specify content type
        //             Authorization: `Bearer ${token}`, // Include the token
        //         },
        //     }
        // )
        // .then(response => {
        //     console.log('searchagentData', response.data.data);
        //     setGroupData(response.data.data);
        // })
        // .catch(error => {
        //     console.error("There was an error fetching the customer data!", error);
        // });
    }

    // const handleEditGroupClick = (groupId) => {
    //     navigate(`/uniteditgroup/${groupId}`); // Use navigate for routing
    // };
    // const handleAddUsersClick = (groupId) => {
    //     navigate(`/unitaddusers/${groupId}`); // Use navigate for routing
    // };
    // const handleUserManagementClick = (groupId) => {
    //     navigate(`/unitusermanagement/${groupId}`); // Use navigate for routing
    // };

    //-------------pagination--------------------
    const [currentPage, setCurrentPage] = useState(1);

    const [rowsPerPage, setRowsPerPage] = useState(20);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = recordData.slice(indexOfFirstRow, indexOfLastRow);
    let totalPages = Math.ceil(recordData.length / rowsPerPage);
    if(recordData.length === 0) {
        totalPages = [1];
    }

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleRowPage = (data) => {
        if (data === '20/page') {
            setRowsPerPage(20);
        }
        if (data === '40/page') {
            setRowsPerPage(40);
        }
        if (data === '60/page') {
            setRowsPerPage(60);
        }
        if (data === '80/page') {
            setRowsPerPage(80);
        }
    }

    return (
        <div className='h-full list-table-scroll'>
            <div className='w-full flex justify-between items-center bg-[#f0f0f0] my-2.5 p-2.5 !mb-0' style={{ fontFamily: 'Liberation Serif' }}>
                <div className='flex items-center'>
                    <div className='flex pl-[80px]'>
                        <div className='flex items-center mr-[20px]'>
                            <span className='mr-[5px] text-[14px] text-[#5a5655]'>Geo-Fence Name</span>
                            <InputField placeholder={'place input the bound name'} className={'!w-[250px]'}/>
                        </div>
                        <div className='flex items-center mr-[20px]'>
                            <span className='mr-[5px] text-[14px] text-[#5a5655]'>Tarigger method</span>
                            <SelectBox1 name={'group_name'} value={searchKey.group_name || ''} onSendData={handleDataFromChild} placeholder={'please select group type'} options={['please select the trigger methods','Exit warning','Enter warning']} />
                        </div>
                        <div>&nbsp;</div>
                    </div> 
                </div>
                <Button onClick={searchRecord} children={'Search'} />
            </div>
            <div className='w-full flex justify-between items-center bg-[#f0f0f0] my-2.5 p-2.5 !mt-0' style={{ fontFamily: 'Liberation Serif' }}>
                <div className='flex pl-[80px]'>
                    <div className='flex items-center'>
                        <div className='flex items-center mr-2.5 py-[5px] px-0'>
                            <span className='mr-[5px] text-[14px] text-[#5a5655]'>Creation Time</span>
                            <DateTimeRangePicker />
                        </div>
                        <div>&nbsp;</div>
                    </div>
                </div>
                <div className='w-[88px]'></div>
            </div>
            <div className='w-full h-[calc(100%-250px)] border-r-0 border-b-0 bg-[#f0f0f0] overflow-auto' ref={containerRef}>
                <table className='table-fixed border-collapse border border-[#ebeef5] !z-0'>
                    <thead className='text-[#909399] font-medium' >
                        <tr className='bg-[#fafafa]' style={{ fontFamily: 'SimSun' }}>
                            {columnWidths.map((width, index) => (
                                <th key={index} style={{ width }} className='border-collapse border border-[#ebeef5] select-none bg-white py-3 min-w-0 truncate align-middle relative text-left text-sm font-normal'>
                                    <div onMouseDown={(e) => handleMouseDown(e, index)} className='cursor-col-resize text-center text-black font-bold break-words leading-[27px] pl-2.5 inline-block relative align-middle pr-2.5 w-full truncate whitespace-normal' style={{ fontFamily: 'Liberation Serif' }}>
                                        {headArray[index]}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className='!z-0'>
                        {/* {groupData.length > 0 && groupData.map((group, Index) => (
                            <tr key={Index} className='bg-[#fafafa]'>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    {group.name || ''}
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    {companyData.company_name || ''}
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    number of user
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    {group.call_duration || ''}
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-lef text-center text-[13px] font-normal p-1'>
                                    <div className='ml-[10px] mr-[10px]'>
                                        <InputSelectBox options={['no data']} inputwidth={221}/>
                                    </div>
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    self-created group leader
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    {group.creation_date || ''}
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    {group.notes || ''}
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    <div className="text-center box-border overflow-hidden text-ellipsis whitespace-normal break-all leading-[23px] px-[10px]">
                                        <span onClick={() => handleAddUsersClick(group.groupId)} className='cursor-pointer text-[#2776c3] whitespace-nowrap'>Add users / </span>
                                        <span onClick={() => handleUserManagementClick(group.groupId)} className='cursor-pointer text-[#2776c3] whitespace-nowrap'>User management / </span>
                                        <span onClick={() => handleEditGroupClick(group.groupId)} className='cursor-pointer text-[#2776c3] whitespace-nowrap'>Edit /</span>
                                        <span onClick={() => handleGroupDelete(group.groupId)} className='cursor-pointer text-[#2776c3] whitespace-nowrap'>Delete</span>
                                    </div>
                                </td>
                            </tr>
                        ))}*/}
                    </tbody> 
                </table>
            </div>
            <div className='flex items-center mt-[12px]' style={{ fontFamily: 'Liberation Serif' }}>
                <div className='flex whitespace-nowrap text-[#303133] font-bold'>
                    <span className='inline-block text-[13px] min-w-[35.5px] h-[28px] leading-[28px] align-top mr-2.5 font-normal text-[#606266]'>totally 0 item</span>
                    <div className="flex justify-center items-center">
                        <button
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="w-[30px] h-[28px] bg-[#f4f4f5] rounded-sm hover:cursor-pointer disabled:cursor-not-allowed mr-2 group pl-2"
                        >
                            <svg
                                className="w-3 fill-[#606266] group-disabled:fill-gray-300"
                                viewBox="0 0 55.753 55.753"
                            >
                                <path
                                    d="M12.745 23.915c.283-.282.59-.52.913-.727L35.266 1.581a5.4 5.4 0 0 1 7.637 7.638L24.294 27.828l18.705 18.706a5.4 5.4 0 0 1-7.636 7.637L13.658 32.464a5.367 5.367 0 0 1-.913-.727 5.367 5.367 0 0 1-1.572-3.911 5.369 5.369 0 0 1 1.572-3.911z"
                                    data-original="#000000"
                                />
                            </svg>
                        </button>

                        <div className="flex space-x-2">
                            {[...Array(totalPages).keys()].map((number) => (
                                <button
                                    key={number}
                                    onClick={() => handlePageChange(number + 1)}
                                    className={`w-[30px] h-[28px] rounded-sm text-sm font-medium ${currentPage === number + 1
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                        }`}
                                >
                                    {number + 1}
                                </button>
                            ))}
                        </div>

                        <button
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="w-[30px] h-[28px] bg-[#f4f4f5] rounded-sm hover:cursor-pointer disabled:cursor-not-allowed ml-3 items-center group pl-2"
                        >
                            <svg
                                className="w-3 fill-[#606266] group-disabled:fill-gray-300 rotate-180"
                                viewBox="0 0 55.753 55.753"
                            >
                                <path
                                    d="M12.745 23.915c.283-.282.59-.52.913-.727L35.266 1.581a5.4 5.4 0 0 1 7.637 7.638L24.294 27.828l18.705 18.706a5.4 5.4 0 0 1-7.636 7.637L13.658 32.464a5.367 5.367 0 0 1-.913-.727 5.367 5.367 0 0 1-1.572-3.911 5.369 5.369 0 0 1 1.572-3.911z"
                                    data-original="#000000"
                                />
                            </svg>
                        </button>
                    </div>
                    <span className='inline-block text-[13px] min-w-[35.5px] h-[28px] leading-[28px] align-top font-normal text-[#606266] ml-[5px]'>
                        Go to
                        <div className='w-[50px] inline-block ml-[5px]'>
                            <input
                                type="text"
                                placeholder="1"
                                className="h-[28px] px-1 text-[14px] rounded-md bg-white border border-[#dcdfe6] w-full outline-blue-500 text-center"
                                value={currentPage}
                                onChange={(e) => setCurrentPage(e.target.value)}
                            />
                        </div>
                    </span>
                    <Button children={'Confirm'} className={'!h-[28px] !py-1 !w-[60px] !px-0 ml-[5px]'} />
                    <SelectBox options={selectPageArray} onSendData={handleRowPage} value={'20/page'} className={'!w-[100px] !h-[28px]'} />
                </div>
            </div>
        </div>
    );
}
export default UnitBoundingList;